import { action } from 'satcheljs';

export const poll = action(
    'poll',
    <T>(requestFunction: () => Promise<T>, requestIdentifier: string, interval: number) => ({
        requestFunction: requestFunction,
        requestIdentifier: requestIdentifier,
        interval: interval,
    })
);

export const responseRetrieved = action(
    'responseRetrieved',
    <T>(response: T, responseIdentifier: string) => ({
        response: response,
        responseIdentifier: responseIdentifier,
    })
);

export const cancelPoll = action('cancelPoll', (requestIdentifier: string) => ({
    requestIdentifier: requestIdentifier,
}));
